module.exports = __webpack_public_path__ + "Lato-Thin.fe4e34a5b0708ee85231.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Thin.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Thin.eot
// module chunks = styles